import Vue from "vue";
import Component from "vue-class-component";
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import {
    IServicesNomenclatures,
    IServicesNomenclaturesListItem, IServicesNomenclaturesTree
} from "@/entity/servicesNomenclature/services.nomenclature.types";

@Component
export class ServicesNomenclatureMix extends Vue {
    get tree(): IServicesNomenclaturesTree[] | null {
        return ServiceNomenclatureStore.tree;
    }
    get service(): IServicesNomenclaturesListItem | null {
        return ServiceNomenclatureStore.service;
    }
    get services(): IServicesNomenclatures | null {
        return ServiceNomenclatureStore.services;
    }
}
